var _circle, _path, _circle2, _ellipse, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _ellipse2, _ellipse3, _ellipse4, _path7, _path8, _path9, _path10, _path11, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCachorro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 130,
    height: 260.84115,
    viewBox: "0 0 864.86498 860.47519",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "walk_dreaming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 215.86498,
    cy: 587.94566,
    r: 215.86498,
    fill: "#2f2e41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.45992,631.09343q0,10.44246-.80952,20.56113-.10788,1.64594-.26977,3.292c-7.51939,83.10793-53.85831,147.68758-110.72083,151.35725h-.0179q-.94451.081-1.8889.10792c-1.07928.054-2.14067.072-3.21995.072a77.07733,77.07733,0,0,1-11.3689-.82752q-.32379-.054-.64757-.10793c-55.27939-8.45473-99.172-74.67131-104.37075-157.79725-.0359-.57565-.07192-1.1513-.08992-1.727q-.45867-7.39335-.44972-14.93064c0-96.86947,52.34721-175.39029,116.92686-175.39029S499.45992,534.224,499.45992,631.09343Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.36779,
    cy: 396.36549,
    r: 147.50774,
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.36779,
    cy: 518.68898,
    rx: 30.58087,
    ry: 7.1955,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.59705,
    cy: 432.34299,
    r: 12.59212,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.13854,
    cy: 432.34299,
    r: 12.59212,
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M380.73418,748.91974a164.79677,164.79677,0,0,1-1.79888,24.50066,148.36766,148.36766,0,0,1-8.41872,32.12788c-55.27939-8.45473-99.172-74.67131-104.37075-157.79725-.0359-.57565-.07192-1.1513-.08992-1.727,10.68532-7.82506,22.75581-12.23232,35.52777-12.23232,37.93832,0,69.63449,38.81964,77.35162,90.64533A164.5509,164.5509,0,0,1,380.73418,748.91974Z",
    transform: "translate(-167.56751 -19.7624)",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.73418,765.10961a164.79667,164.79667,0,0,1-1.79888,24.50066C372.927,829.905,352.41991,862.35678,325.74256,874.769a57.73838,57.73838,0,0,1-15.974,4.857,53.79485,53.79485,0,0,1-8.18486.61167,56.14144,56.14144,0,0,1-22.48593-4.73105,66.69915,66.69915,0,0,1-15.81207-9.64195c-24.35684-19.60777-40.85249-57.38415-40.85249-100.755,0-63.59029,35.43786-115.128,79.15049-115.128,37.93832,0,69.63449,38.81964,77.35162,90.64533A164.5509,164.5509,0,0,1,380.73418,765.10961Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M498.6504,651.65456q-.10788,1.64594-.26977,3.292c-7.51939,83.10793-53.85831,147.68758-110.72083,151.35725h-.0179a149.175,149.175,0,0,1-8.7066-32.88338,167.62669,167.62669,0,0,1,0-48.98332c7.71714-51.82569,39.4133-90.64533,77.35162-90.64533C471.86513,633.79175,486.40007,640.33968,498.6504,651.65456Z",
    transform: "translate(-167.56751 -19.7624)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M535.43741,765.10961c0,47.67018-19.91356,88.55857-48.28185,106.04369a61.45258,61.45258,0,0,1-15.25442,6.8357,55.28509,55.28509,0,0,1-30.90466.08993,62.29938,62.29938,0,0,1-17.03529-7.84307c-22.64788-14.7508-39.64727-44.54016-45.02589-80.62559a167.62669,167.62669,0,0,1,0-48.98332c7.71714-51.82569,39.4133-90.64533,77.35162-90.64533C499.99956,649.98162,535.43741,701.51932,535.43741,765.10961Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M378.9353,446.70876c-44.70715,0-80.94936,30.36348-80.94936,61.16175,0,18.0611,12.47431,34.10791,31.8,44.29894C336.98,538.93426,356.26469,529.457,378.9353,529.457s41.95527,9.47725,49.14934,22.71244c19.32572-10.191,31.8-26.23784,31.8-44.29894C459.88467,477.07224,423.64246,446.70876,378.9353,446.70876Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#d9485d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.77004,
    cy: 491.70586,
    rx: 21.5865,
    ry: 17.98875,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.75949,
    cy: 369.38237,
    rx: 30.58087,
    ry: 58.46343,
    fill: "#d9485d"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.98172,
    cy: 369.38237,
    rx: 30.58087,
    ry: 58.46343,
    fill: "#d9485d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M412.21449,249.732a17.89846,17.89846,0,0,0-11.18731,3.91692,26.94538,26.94538,0,0,0-48.55534,5.485,17.98875,17.98875,0,1,0,0,17.17364,26.94538,26.94538,0,0,0,48.55534,5.485A17.98386,17.98386,0,1,0,412.21449,249.732Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M279.09775,809.182v66.32451a66.69915,66.69915,0,0,1-15.81207-9.64195Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M325.74256,874.769a57.73838,57.73838,0,0,1-15.974,4.857l8.41872-60.712Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M440.99648,809.182v68.89689a62.29938,62.29938,0,0,1-17.03529-7.84307Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M487.15556,871.1533a61.45258,61.45258,0,0,1-15.25442,6.8357l8.18486-59.07509Z",
    transform: "translate(-167.56751 -19.7624)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.86498,
    cy: 429.97519,
    r: 4,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.86498,
    cy: 429.97519,
    r: 4,
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCachorro);
export default __webpack_public_path__ + "static/media/cachorro.5bfa3ac7d23b76c721cf81973dfb201a.svg";
export { ForwardRef as ReactComponent };